import React from 'react';
import { usePageHasOwnHeading } from './BreadcrumbContext';
import { useTrail } from './useTrail';

/**
 * The page's name as its heading, for screen readers: pages no longer show a
 * title of their own, and the breadcrumb is a nav, not a heading.
 */
export const PageHeading: React.FC = () => {
  const trail = useTrail();
  const hasOwnHeading = usePageHasOwnHeading();
  const current = trail[trail.length - 1];
  if (!current || hasOwnHeading) return null;
  return <h1 className='sr-only'>{current.label}</h1>;
};
